class ContactDatePicker {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const dateWrap = "." + this.el;
    $(dateWrap).each(function(){
      $(this).find('input[type=text]').attr('type','date');
    })
  }
}
